import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { deepCopy, removeUndefined } from 'na-lib';
import { languagesList, languagesList_ } from 'na-lib';
import { validColorValidator } from 'src/app/validators/color.validator';
import { SettingsService } from 'src/app/service/settings.service';

@Component({
    selector: 'app-form-edit',
    templateUrl: './chat-edit.component.html',
    styleUrls: ['./chat-edit.component.css'],
    standalone: false
})
export class ChatEditComponent {
  formEditForm!:FormGroup
  formData:any
  oldData:any
  widgetNumber:any
  passId:any
  payloadContentEdit:any =[]
  panelOpenState = false

  allIdsSections:any =[]
  allKeysSection:any=[]
  buttonStyleForm!:FormGroup

  suggestions:string[]=[]
  payloadMapping:any[]=[]

  invalid_primary = false
  invalid_borderColor = false
  invalid_background = false

  colorPalette:any=[]

  buttonStyleDefault:any = {
    "background": "#ff5d38",
    "borderColor": "#ff5d38",
    "borderWidth": 0,
    "primary": "#fefefe",
    //"cornerRadius": 0
  }
  languagesList = languagesList
  defaultLanguage:string
  userHasBetaWidgetRole = false

  constructor(public dialogRef: MatDialogRef<ChatEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public dialog: MatDialog,
    //private commentService: CommentsService,
    private translate:TranslateService,
    private settingsService:SettingsService
  ){
    dialogRef.disableClose = true;
    const currentLang = this.translate.currentLang() ?? 'en';
    this.languagesList = languagesList_[currentLang]
  }

  ngOnInit():void{
    if(this.settingsService.checkIfBetaRoleAccess())
      this.userHasBetaWidgetRole = true
    
    this.defaultLanguage = this.data.defaultLanguage
    this.initializePaletteColors()

    this.formData = this.data.values
    this.oldData = deepCopy(this.formData)
    this.passId = this.data['passId']
    this.widgetNumber= this.data['widget']

    this.formEditForm = this.fb.group({
      type:[],
      suggestions: this.fb.array([]),
      payloadMapping:this.fb.array([]),
      id:[],
      title:[],
      subtitle:[],
      name:[],
      buttonImageURL:[],
      //prompt:[],
      buttonStyle:[],
      filter:[],
      widgetStyle:[],
      viewMode:[]
    })

    const suggestions = this.formData?.suggestions || [];
    const suggestionsArray = this.formEditForm.get('suggestions') as FormArray;
    suggestions.forEach(s => suggestionsArray.push(this.fb.control(s)));

    const payloadMapping = this.formData?.payloadMapping || [];
    const payloadArray = this.formEditForm.get('payloadMapping') as FormArray;
    payloadMapping.forEach(obj => payloadArray.push(this.fb.control(obj.key)));

    const { type, filter, id, title, subtitle, name, viewMode, buttonImageURL, widgetStyle, buttonStyle} = this.formData

    this.formEditForm.patchValue({
      name: name ? name : undefined,
      subtitle: subtitle ? subtitle : undefined,
      type:type ? type : "chat",
      id: id ? id : undefined,
      title:title ? title : undefined,
      buttonImageURL: buttonImageURL ? buttonImageURL : undefined,
      //prompt: prompt ? prompt : undefined,
      // currently only light mode is supported
      buttonStyle: buttonStyle ? buttonStyle : undefined,
      filter: filter? filter: undefined,
      widgetStyle: widgetStyle ? widgetStyle : undefined,
      viewMode:viewMode ? viewMode : "button"
    })
    
    if (this.formData.suggestions) {
      const suggestions = this.formData?.suggestions || [];
      this.suggestionsArray.clear(); 
      suggestions.forEach(s => this.suggestionsArray.push(this.fb.control(s)));
      this.formEditForm.patchValue({
        suggestions: this.formData.suggestions
      })
    } else {
      this.suggestions = [];
    }

if (this.formData.payloadMapping) {
  const payloadMapping = this.formData?.payloadMapping || [];
  this.payloadArray.clear();
  payloadMapping.forEach(obj => this.payloadArray.push(this.fb.control(obj.key)));
  // REMOVE this, because it patches objects into controls expecting strings
  // this.formEditForm.patchValue({
  //   payloadMapping: this.formData.payloadMapping
  // })
} else {
  this.payloadMapping = [];
}


    this.buttonStyleForm = this.fb.group({
      background: [, [validColorValidator()]],
      primary: [, [validColorValidator()]],
      borderColor: [, [validColorValidator()]],
      borderWidth: [],
      //cornerRadius: []
    })

    if( buttonStyle){
      //const {background, primary, borderColor, borderWidth} = buttonStyle
      const { lightColors, borderWidth } = buttonStyle;
      const { background, primary, border } = lightColors || {};

     this.buttonStyleForm.patchValue({
      background: background ?? this.buttonStyleDefault.background,
      primary: primary ?? this.buttonStyleDefault.primary,
      borderColor: border ?? this.buttonStyleDefault.borderColor,
      borderWidth: borderWidth ?? this.buttonStyleDefault.borderWidth
    });
    }else{
      this.buttonStyleForm.patchValue( {
        background: this.buttonStyleDefault.background,
        primary: this.buttonStyleDefault.primary,
        borderColor: this.buttonStyleDefault.borderColor,
        borderWidth: this.buttonStyleDefault.borderWidth,
        //cornerRadius: this.buttonStyleDefault.cornerRadius
      })
    }
    this.buttonStyleForm.valueChanges.subscribe( value => {
      this.checkInvalidColors()
    })
    this.checkInvalidColors()
  }

  get suggestionsArray(): FormArray<FormControl<string>> {
    return this.formEditForm.get('suggestions') as FormArray<FormControl<string>>;
  }

  get payloadArray(): FormArray<FormControl<string>> {
    return this.formEditForm.get('payloadMapping') as FormArray<FormControl<string>>;
  }

  checkInvalidColors(){
    if(this.buttonStyleForm.controls['background'].hasError('invalidColor')){
      this.invalid_background=true
    }else{
      this.invalid_background=false
    }
    if(this.buttonStyleForm.controls['primary'].hasError('invalidColor')){
      this.invalid_primary=true
    }else{
      this.invalid_primary=false
    }
    if(this.buttonStyleForm.controls['borderColor'].hasError('invalidColor')){
      this.invalid_borderColor=true
    }else{
      this.invalid_borderColor=false
    }
  }

  addSuggestion() {
    this.suggestionsArray.push(this.fb.control(''));
  }

  addPayloadContent() {
    this.payloadArray.push(this.fb.control(''));
  }
  deleteSuggestion(index: number) {
    this.suggestionsArray.removeAt(index);
  }

  deletePayloadContent(index: number){
      this.payloadArray.removeAt(index);
  }

  dialogCancel(){
    this.dialogRef.close([this.formData, false])
  }

  dialogSave() {
  const suggestions = this.suggestionsArray.value;
  this.formEditForm.get('suggestions')?.setValue(suggestions);

  // Transform array of strings into array of { key: string }
  const payloadMappingStrings = this.payloadArray.value;
  const payloadMappingObjects = payloadMappingStrings.map(entry => ({ key: entry }));
  this.formEditForm.get('payloadMapping')?.setValue(payloadMappingObjects);

  const { background, primary, borderColor, borderWidth } = this.buttonStyleForm.value;

  // currently support only light colors
  this.formEditForm.get('buttonStyle')?.setValue({
    lightColors: {
      background,
      primary,
      borderColor
    },
    borderWidth
  });

  const data = this.formEditForm.value;
  removeUndefined(data);
  this.dialogRef.close([data, true]);
}


/*   dialogSave() {
  const suggestions = this.suggestionsArray.value;
  this.formEditForm.get('suggestions')?.setValue(suggestions);

  const payloadMapping = this.payloadArray.value;
  this.formEditForm.get('payloadMapping')?.setValue(payloadMapping);

  const { background, primary, borderColor, borderWidth } = this.buttonStyleForm.value;

  // currently support only light colors
  this.formEditForm.get('buttonStyle')?.setValue({
    lightColors: {
      background,
      primary,
      borderColor: borderColor
    },
    borderWidth
  });

  const data = this.formEditForm.value;
  removeUndefined(data);
  this.dialogRef.close([data, true]);
} */

  initializePaletteColors(){
    var colors=[]
    const warmOrange= getComputedStyle(document.documentElement).getPropertyValue('--warmOrange')
    const darkblue= getComputedStyle(document.documentElement).getPropertyValue('--darkBlue')
    const pureWhite= getComputedStyle(document.documentElement).getPropertyValue('--pureWhite')
    const neutral= getComputedStyle(document.documentElement).getPropertyValue('--neutral')
    colors.push(warmOrange)
    colors.push(darkblue)
    colors.push(pureWhite)
    colors.push(neutral)
    this.colorPalette=colors
  }

  returnChangesFilters($event){
    this.formEditForm.patchValue({filter: $event.newFilters})
  }

  returnChangesStyle($event){
    this.formEditForm.patchValue({widgetStyle: $event.newStyle})
  }
}
